<template>
  <div class="h-screen bg-[#f7f7f7] flex flex-col overflow-hidden">
    <nav
      class="fixed top-0 left-0 right-0 z-40 flex items-center h-12 min-h-[3rem] bg-white border-b border-gray-200 px-4"
    >
      <router-link to="/" class="flex items-center shrink-0">
        <img src="@/assets/tracktalent_logo.svg" alt="Logo" class="h-7" />
      </router-link>

      <div id="topbar-search" class="hidden md:flex absolute left-1/2 -translate-x-1/2 w-full max-w-2xl px-4"></div>

      <div class="flex items-center gap-2 ml-auto">
        <div id="topbar-right" class="hidden md:flex px-4"></div>
        <button
          v-if="isGuide"
          :title="isBlurred ? 'Show sensitive data' : 'Hide sensitive data'"
          class="flex items-center justify-center hover:bg-gray-100 rounded-full w-8 h-8"
          @click="toggleBlur"
        >
          <EyeOff v-if="isBlurred" class="w-4.5 h-4.5 text-gray-500" />
          <Eye v-else class="w-4.5 h-4.5 text-gray-500" />
        </button>
        <ProfileDropdown />
      </div>
    </nav>

    <SidebarMenu class="z-40" />

    <div
      class="pt-12 flex-1 min-h-0 flex flex-col overflow-y-auto transition-[padding-left] duration-300 ease-in-out"
      :class="isSidebarCollapsed ? 'md:pl-16' : 'md:pl-60'"
    >
      <div class="flex-1 min-h-0 p-4 py-2 w-full flex flex-col">
        <router-view class="flex-1 min-h-0" />
      </div>
    </div>

    <button
      class="md:hidden fixed bottom-4 left-4 z-50 flex items-center justify-center w-10 h-10 bg-white border border-gray-200 rounded-full shadow-md"
      @click="isMobileSidebarOpen = !isMobileSidebarOpen"
      aria-label="Toggle Sidebar"
    >
      <Menu class="w-5 h-5 text-gray-600" />
    </button>

    <div
      v-if="isMobileSidebarOpen"
      class="md:hidden fixed inset-0 bg-black/30 z-30"
      @click="isMobileSidebarOpen = false"
    />
  </div>
</template>

<script setup>
import ProfileDropdown from '@/components/common/ProfileDropdown.vue'
import SidebarMenu from '@/components/layout/SidebarMenu.vue'
import { Menu, Eye, EyeOff } from 'lucide-vue-next'
import { ref, provide, onMounted, watch } from 'vue'
import { useLocalStorage } from '@vueuse/core'
import { useAuth } from '@/composables/useAuth'
import { usePrivacy } from '@/composables/usePrivacy'
import { useUserStore } from '@/stores/user'
import { useRoute } from 'vue-router'

const { isGuide } = useAuth()
const { isBlurred, toggleBlur } = usePrivacy()
const userStore = useUserStore()
const route = useRoute()

const isMobileSidebarOpen = ref(false)
const isSidebarCollapsed = useLocalStorage('sidebar-collapsed', false)
provide('isMobileSidebarOpen', isMobileSidebarOpen)
provide('isSidebarCollapsed', isSidebarCollapsed)

onMounted(async () => {
  await userStore.fetchCurrentUser()
})

watch(
  () => route.path,
  () => {
    isMobileSidebarOpen.value = false
  }
)
</script>
